"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var api_service_1 = require("../../../api/api_service");
var button_component_1 = require("../../../common/buttons/button_component");
var multi_selector_1 = require("../../../common/checkbox/multi_selector");
var drop_down_component_1 = require("../../../common/drop_down/drop_down_component");
var search_component_1 = require("../../../common/search/search_component");
var appConstants_1 = require("../../../constants/appConstants");
var array_helpers_1 = require("../../../utils/array_helpers");
var FilterComponent = function (_a) {
    var searchHadler = _a.searchHadler, searchValue = _a.searchValue, cityHandlere = _a.cityHandlere, citiesValues = _a.citiesValues, placeHolder = _a.placeHolder, makeCityEmpty = _a.makeCityEmpty, CurrentPagelimit = _a.CurrentPagelimit, onPageLimitChange = _a.onPageLimitChange, displayNoOfRowFiler = _a.displayNoOfRowFiler, activetab = _a.activetab, setIsFilterButton = _a.setIsFilterButton, isFilterButton = _a.isFilterButton, onchangeBillingModule = _a.onchangeBillingModule, billingModule = _a.billingModule;
    var _b = React.useState(), stateData = _b[0], setStateData = _b[1];
    var _c = (0, react_redux_1.useSelector)(function (store) { return store.appConfigList; }), stateList = _c.stateList, billing_modules = _c.billing_modules;
    var _d = React.useState([]), citiesData = _d[0], setCitiesData = _d[1];
    var stateHandlere = function (value) {
        setStateData(value);
        makeCityEmpty();
    };
    var FilterHandler = function () {
        setIsFilterButton(!isFilterButton);
    };
    var fetchCities = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2, new Promise(function (resolve, reject) {
                    if (stateData && stateData.length >= 1) {
                        api_service_1.api_service
                            .post({
                            endPoint: api_service_1.api_service.api_urls.CITIES,
                            domain: process.env.VENDOR_BASE_URL,
                            payLoad: {
                                state_id: stateData &&
                                    stateData.map(function (state) {
                                        return state.id;
                                    }),
                            },
                        })
                            .then(function (response) {
                            if (response.status === 200) {
                                var stateResponse = (0, array_helpers_1.convertLabelAndValueCity)(response.data.data.cities);
                                setCitiesData(stateResponse);
                                return resolve(response.data.data);
                            }
                            throw new Error(response.data.message);
                        })
                            .catch(function (err) {
                            return reject(err);
                        });
                    }
                    else {
                        setCitiesData([]);
                    }
                })];
        });
    }); };
    React.useEffect(function () {
        fetchCities();
    }, [stateData]);
    React.useEffect(function () {
        setStateData([]);
    }, [activetab]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "filter-menu-wrapper" },
            React.createElement("div", { className: "search-filter" },
                React.createElement(search_component_1.default, { placeholder: placeHolder
                        ? placeHolder
                        : 'Search FE Name / Mobile No / FE ID', className: 'fe-search-module', searchValue: searchValue, searchHandler: searchHadler, activetab: activetab })),
            React.createElement("div", { className: "filter-options" },
                React.createElement(multi_selector_1.default, { label: "Select State", dropDownList: stateList &&
                        stateList.sort(function (a, b) {
                            return a.label.localeCompare(b.label);
                        }), onChangeHnadlre: stateHandlere, value: stateData }),
                React.createElement(multi_selector_1.default, { label: "Select City", dropDownList: citiesData &&
                        citiesData.sort(function (a, b) {
                            return a.label.localeCompare(b.label);
                        }), onChangeHnadlre: cityHandlere, value: citiesValues, hasSelectAll: true, noOptions: 'No cities found' }),
                displayNoOfRowFiler && (React.createElement(drop_down_component_1.default, { placeholder: "Module Type", dropDownList: billing_modules, onChange: onchangeBillingModule, value: billingModule })),
                displayNoOfRowFiler && (React.createElement(drop_down_component_1.default, { dropDownList: appConstants_1.paginationDropdown, onChange: onPageLimitChange, value: CurrentPagelimit })),
                React.createElement(button_component_1.default, { buttonName: "FILTERS", color: "yellow-outline", onClickHandler: FilterHandler })))));
};
exports.default = FilterComponent;
